import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function CustomerPage() {
  const [selectedTable, setSelectedTable] = useState('');
  const [cart, setCart] = useState<any[]>([]);
  const [activeCategory, setActiveCategory] = useState('makanan');
  const [orderStep, setOrderStep] = useState(1); // 1: Table, 2: Food, 3: Drinks, 4: Review
  const [customerInfo, setCustomerInfo] = useState({
    name: '',
    phone: '',
    notes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOrderForm, setShowOrderForm] = useState(true);
  const [showTableInfo, setShowTableInfo] = useState(false);
  const [selectedTableInfo, setSelectedTableInfo] = useState<any>(null);

  const tables = [
    { id: 'A1', name: 'Meja A1', status: 'available', capacity: '2-4 orang', location: 'Window View' },
    { 
      id: 'A2', 
      name: 'Meja A2', 
      status: 'occupied', 
      capacity: '2-4 orang', 
      location: 'Corner Table',
      currentGuest: {
        name: 'Keluarga Sato',
        startTime: '19:30',
        estimatedEnd: '21:00',
        partySize: 3,
        orderValue: 285000,
        specialRequests: 'No spicy food, extra wasabi'
      }
    },
    { id: 'B1', name: 'Meja B1', status: 'available', capacity: '4-6 orang', location: 'Center Hall' },
    { id: 'B2', name: 'Meja B2', status: 'available', capacity: '4-6 orang', location: 'Private Booth' },
    { id: 'C1', name: 'Meja C1', status: 'available', capacity: '6-8 orang', location: 'Family Table' },
    { 
      id: 'VIP1', 
      name: 'VIP Room 1', 
      status: 'reserved', 
      capacity: '8-12 orang', 
      location: 'Tatami Style',
      reservation: {
        name: 'Corporate Meeting - PT Sakura',
        time: '20:00',
        partySize: 10,
        specialRequests: 'Business meeting setup, projector needed'
      }
    },
    { id: 'VIP2', name: 'VIP Room 2', status: 'available', capacity: '8-12 orang', location: 'Modern Style' }
  ];

  const menuItems = {
    makanan: [
      {
        id: 'ramen-tonkotsu',
        name: 'Tonkotsu Ramen Deluxe',
        price: 75000,
        description: 'Kuah tulang babi premium dengan telur ajitsuke, chashu, dan bambu menma',
        image: 'https://public.readdy.ai/ai/img_res/e05e7bf981fb2f3cb268eca469d94952.jpg',
        category: 'Ramen',
        available: true
      },
      {
        id: 'sushi-omakase',
        name: 'Omakase Sushi Set',
        price: 150000,
        description: 'Set sushi pilihan chef dengan 12 pieces nigiri sushi premium',
        image: 'https://readdy.ai/api/search-image?query=Premium%20omakase%20sushi%20set%20with%2012%20pieces%20of%20nigiri%20sushi%2C%20fresh%20salmon%2C%20tuna%2C%20yellowtail%2C%20sea%20urchin%2C%20elegant%20wooden%20board%20presentation%2C%20wasabi%20and%20pickled%20ginger%2C%20high-end%20Japanese%20restaurant%20quality&width=300&height=200&seq=customer-sushi-omakase&orientation=landscape',
        category: 'Sushi',
        available: true
      },
      {
        id: 'tempura-set',
        name: 'Tempura Premium Set',
        price: 85000,
        description: 'Tempura udang dan sayuran dengan tepung crispy dan saus tentsuyu',
        image: 'https://readdy.ai/api/search-image?query=Premium%20tempura%20set%20with%20crispy%20shrimp%20and%20vegetable%20tempura%2C%20golden%20brown%20coating%2C%20tentsuyu%20dipping%20sauce%2C%20elegant%20Japanese%20presentation%2C%20professional%20food%20photography&width=300&height=200&seq=customer-tempura-set&orientation=landscape',
        category: 'Tempura',
        available: true
      },
      {
        id: 'gyoza-premium',
        name: 'Gyoza Premium',
        price: 45000,
        description: '6 pieces gyoza dengan isian daging dan sayuran, pan-fried hingga crispy',
        image: 'https://readdy.ai/api/search-image?query=Premium%20gyoza%20dumplings%20pan-fried%20until%20golden%20crispy%2C%206%20pieces%20arranged%20on%20black%20plate%2C%20dipping%20sauce%2C%20steam%20rising%2C%20traditional%20Japanese%20appetizer%2C%20restaurant%20quality%20presentation&width=300&height=200&seq=customer-gyoza-premium&orientation=landscape',
        category: 'Appetizer',
        available: false
      }
    ],
    minuman: [
      {
        id: 'matcha-latte',
        name: 'Matcha Latte Premium',
        price: 35000,
        description: 'Matcha authentic dari Uji dengan susu premium dan foam art',
        image: 'https://readdy.ai/api/search-image?query=Premium%20matcha%20latte%20with%20beautiful%20foam%20art%2C%20vibrant%20green%20matcha%20color%2C%20ceramic%20cup%20and%20saucer%2C%20Japanese%20tea%20ceremony%20aesthetic%2C%20modern%20cafe%20presentation%2C%20authentic%20Uji%20matcha&width=300&height=200&seq=customer-matcha-latte&orientation=landscape',
        category: 'Hot Drinks',
        available: true
      },
      {
        id: 'ramune-soda',
        name: 'Ramune Soda',
        price: 25000,
        description: 'Soda Jepang traditional dengan marble ball, rasa original',
        image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20ramune%20soda%20bottle%20with%20marble%20ball%2C%20clear%20blue%20tinted%20glass%20bottle%2C%20condensation%20droplets%2C%20refreshing%20summer%20drink%2C%20Japanese%20beverage%2C%20traditional%20packaging&width=300&height=200&seq=customer-ramune-soda&orientation=landscape',
        category: 'Cold Drinks',
        available: true
      },
      {
        id: 'green-tea',
        name: 'Ocha (Green Tea)',
        price: 15000,
        description: 'Teh hijau Jepang authentic disajikan panas dalam kyusu',
        image: 'https://readdy.ai/api/search-image?query=Traditional%20Japanese%20green%20tea%20ocha%20served%20in%20ceramic%20kyusu%20teapot%20with%20small%20cups%2C%20steam%20rising%2C%20zen%20atmosphere%2C%20traditional%20tea%20ceremony%2C%20minimalist%20presentation&width=300&height=200&seq=customer-ocha-green-tea&orientation=landscape',
        category: 'Hot Drinks',
        available: true
      }
    ]
  };

  const addToCart = (item: any) => {
    const existingItem = cart.find(cartItem => cartItem.id === item.id);
    if (existingItem) {
      setCart(cart.map(cartItem => 
        cartItem.id === item.id 
          ? { ...cartItem, quantity: cartItem.quantity + 1 }
          : cartItem
      ));
    } else {
      setCart([...cart, { ...item, quantity: 1 }]);
    }
  };

  const removeFromCart = (itemId: string) => {
    setCart(cart.filter(item => item.id !== itemId));
  };

  const updateQuantity = (itemId: string, quantity: number) => {
    if (quantity <= 0) {
      removeFromCart(itemId);
    } else {
      setCart(cart.map(item => 
        item.id === itemId ? { ...item, quantity } : item
      ));
    }
  };

  const getTotalPrice = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const handleNextStep = () => {
    if (orderStep < 4) {
      setOrderStep(orderStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (orderStep > 1) {
      setOrderStep(orderStep - 1);
    }
  };

  const handleTableClick = (table: any) => {
    if (table.status === 'available') {
      setSelectedTable(table.id);
      // Langsung lanjut ke step berikutnya setelah pilih meja tersedia
      if (orderStep === 1) {
        setOrderStep(2);
      }
    } else {
      // Show table info modal for occupied/reserved tables
      setSelectedTableInfo(table);
      setShowTableInfo(true);
    }
  };

  const getEstimatedWaitTime = (table: any) => {
    if (table.status === 'occupied' && table.currentGuest) {
      const endTime = table.currentGuest.estimatedEnd;
      const currentTime = new Date();
      const currentHour = currentTime.getHours();
      const currentMinute = currentTime.getMinutes();
      const [endHour, endMinute] = endTime.split(':').map(Number);
      
      const currentTotalMinutes = currentHour * 60 + currentMinute;
      const endTotalMinutes = endHour * 60 + endMinute;
      
      if (endTotalMinutes > currentTotalMinutes) {
        const waitMinutes = endTotalMinutes - currentTotalMinutes;
        return `~${Math.ceil(waitMinutes / 15) * 15} menit`;
      }
    }
    return 'Tidak tersedia';
  };

  const handleSubmitOrder = async () => {
    if (cart.length === 0) {
      alert('Keranjang masih kosong!');
      return;
    }

    if (!selectedTable) {
      alert('Silakan pilih nomor meja terlebih dahulu!');
      return;
    }

    setIsSubmitting(true);

    try {
      const orderData = {
        table: selectedTable,
        customer: {
          name: customerInfo.name,
          phone: customerInfo.phone,
          notes: customerInfo.notes
        },
        items: cart,
        total: getTotalPrice()
      };

      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/submit-order`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`
        },
        body: JSON.stringify(orderData)
      });

      const result = await response.json();

      if (result.success) {
        alert(`Pesanan berhasil dikirim ke sistem!\nID Pesanan: ${result.orderId}\n\nPesanan akan segera diproses oleh kasir dan dapur.`);
        
        // Reset form
        setCart([]);
        setCustomerInfo({ name: '', phone: '', notes: '' });
        setSelectedTable('');
        setShowOrderForm(false);
      } else {
        alert(`Gagal mengirim pesanan: ${result.error}`);
      }
    } catch (error) {
      console.error('Error submitting order:', error);
      alert('Terjadi kesalahan saat mengirim pesanan. Silakan coba lagi.');
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    // Add JSON-LD structured data for menu page
    const menuSchema = {
      "@context": "https://schema.org",
      "@type": "Menu",
      "name": "Menu TAKEYA Restaurant",
      "description": "Menu lengkap restoran Jepang TAKEYA dengan berbagai pilihan ramen, sushi, dan hidangan Jepang autentik lainnya.",
      "hasMenuSection": [
        {
          "@type": "MenuSection",
          "name": "Ramen",
          "description": "Koleksi ramen autentik Jepang dengan kuah kaya rasa"
        },
        {
          "@type": "MenuSection", 
          "name": "Sushi & Sashimi",
          "description": "Sushi dan sashimi segar dengan ikan berkualitas premium"
        },
        {
          "@type": "MenuSection",
          "name": "Appetizer",
          "description": "Pembuka khas Jepang untuk melengkapi pengalaman bersantap"
        },
        {
          "@type": "MenuSection",
          "name": "Minuman",
          "description": "Minuman tradisional dan modern Jepang"
        }
      ],
      "inLanguage": "id",
      "offers": {
        "@type": "Offer",
        "availabilityEnds": "2025-12-31",
        "availabilityStarts": "2024-01-01"
      }
    };

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": import.meta.env.VITE_SITE_URL || "https://example.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Menu",
          "item": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/customer`
        }
      ]
    };

    // Remove existing schema scripts
    const existingSchemas = document.querySelectorAll('script[type="application/ld+json"]');
    existingSchemas.forEach(script => script.remove());

    // Add new schema scripts
    const menuScript = document.createElement('script');
    menuScript.type = 'application/ld+json';
    menuScript.textContent = JSON.stringify(menuSchema);
    document.head.appendChild(menuScript);

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScript);

    // Update page title and meta tags
    document.title = "Menu - TAKEYA Restaurant | Hidangan Jepang Autentik";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Jelajahi menu lengkap TAKEYA Restaurant dengan berbagai pilihan ramen, sushi, dan hidangan Jepang autentik lainnya. Pesan online sekarang!');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'menu takeya, ramen bukittinggi, sushi jepang, hidangan jepang, restoran jepang menu, pesan online');
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Menu - TAKEYA Restaurant | Hidangan Jepang Autentik');
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', 'Jelajahi menu lengkap TAKEYA Restaurant dengan berbagai pilihan ramen, sushi, dan hidangan Jepang autentik lainnya. Pesan online sekarang!');
    }

    // Cleanup function
    return () => {
      const schemas = document.querySelectorAll('script[type="application/ld+json"]');
      schemas.forEach(script => script.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black">
      {/* Header */}
      <div className="bg-gradient-to-r from-red-900/50 to-yellow-900/50 backdrop-blur-sm border-b border-red-500/20">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-4">
              <span className="text-6xl" style={{ fontFamily: '"Noto Sans JP", serif' }}>竹</span>
              <div>
                <h1 className="text-2xl font-bold text-white">TAKEYA</h1>
                <p className="text-yellow-400 text-sm">Customer Order System</p>
              </div>
            </Link>
            
            {/* Cart Summary */}
            <div className="flex items-center space-x-4">
              <div className="bg-black/30 rounded-2xl px-6 py-3">
                <div className="flex items-center space-x-4">
                  <div className="text-center">
                    <p className="text-white font-bold text-lg">{cart.length}</p>
                    <p className="text-gray-300 text-xs">Items</p>
                  </div>
                  <div className="w-px h-8 bg-gray-600"></div>
                  <div className="text-center">
                    <p className="text-yellow-400 font-bold text-lg">
                      Rp {getTotalPrice().toLocaleString('id-ID')}
                    </p>
                    <p className="text-gray-300 text-xs">Total</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Progress Steps */}
      <div className="bg-gray-800/50 backdrop-blur-sm border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-center space-x-8">
            {[
              { step: 1, title: 'Pilih Meja', icon: 'ri-home-5-line' },
              { step: 2, title: 'Pilih Makanan', icon: 'ri-bowl-line' },
              { step: 3, title: 'Pilih Minuman', icon: 'ri-cup-line' },
              { step: 4, title: 'Review & Pesan', icon: 'ri-check-line' }
            ].map((item) => (
              <div key={item.step} className="flex items-center space-x-3">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  orderStep >= item.step 
                    ? 'bg-red-600 text-white' 
                    : 'bg-gray-600 text-gray-300'
                }`}>
                  <i className={`${item.icon} w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <span className={`font-semibold ${
                  orderStep >= item.step ? 'text-white' : 'text-gray-400'
                }`}>
                  {item.title}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Step 1: Table Selection */}
        {orderStep === 1 && (
          <div>
            <div className="text-center mb-8">
              <h2 className="text-4xl font-bold text-white mb-4">Pilih Meja Anda</h2>
              <p className="text-gray-300">Silakan pilih meja yang tersedia untuk pengalaman dining terbaik</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              {tables.map((table) => (
                <div
                  key={table.id}
                  className={`border-2 rounded-3xl p-6 cursor-pointer transition-all duration-300 ${
                    table.status === 'available' 
                      ? selectedTable === table.id
                        ? 'border-red-500 bg-red-900/20'
                        : 'border-gray-600 bg-gray-800/50 hover:border-red-400'
                      : 'border-gray-700 bg-gray-900/50 hover:border-gray-500'
                  }`}
                  onClick={() => handleTableClick(table)}
                >
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h3 className="text-xl font-bold text-white">{table.name}</h3>
                      <p className="text-gray-300 text-sm">{table.location}</p>
                    </div>
                    <div className={`px-3 py-1 rounded-full text-xs font-bold ${
                      table.status === 'available' ? 'bg-green-500 text-white' :
                      table.status === 'occupied' ? 'bg-red-500 text-white' :
                      'bg-yellow-500 text-black'
                    }`}>
                      {table.status === 'available' ? 'Tersedia' :
                       table.status === 'occupied' ? 'Terisi' : 'Reserved'}
                    </div>
                  </div>
                  <div className="flex items-center space-x-3 mb-3">
                    <i className="ri-group-line text-gray-400 w-4 h-4 flex items-center justify-center"></i>
                    <span className="text-gray-300 text-sm">{table.capacity}</span>
                  </div>
                  
                  {table.status === 'occupied' && (
                    <div className="mt-3 pt-3 border-t border-gray-700">
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-gray-400">Estimasi tersedia:</span>
                        <span className="text-yellow-400 font-bold">{getEstimatedWaitTime(table)}</span>
                      </div>
                    </div>
                  )}
                  
                  {table.status === 'reserved' && (
                    <div className="mt-3 pt-3 border-t border-gray-700">
                      <div className="flex items-center justify-between text-xs">
                        <span className="text-gray-400">Reservasi:</span>
                        <span className="text-yellow-400 font-bold">{table.reservation?.time}</span>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="text-center">
              <Button
                variant="primary"
                size="lg"
                onClick={handleNextStep}
                disabled={!selectedTable}
                className="whitespace-nowrap cursor-pointer"
              >
                Lanjut ke Menu Makanan
                <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
              </Button>
            </div>
          </div>
        )}

        {/* Step 2 & 3: Menu Selection */}
        {(orderStep === 2 || orderStep === 3) && (
          <div>
            <div className="text-center mb-8">
              <h2 className="text-4xl font-bold text-white mb-4">
                {orderStep === 2 ? 'Pilih Makanan' : 'Pilih Minuman'}
              </h2>
              <p className="text-gray-300">
                {orderStep === 2 ? 'Pilih makanan favorit Anda' : 'Lengkapi dengan minuman pilihan'}
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              {menuItems[orderStep === 2 ? 'makanan' : 'minuman'].map((item) => (
                <div
                  key={item.id}
                  className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 overflow-hidden"
                >
                  <div className="relative">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-48 object-cover object-top"
                    />
                    {!item.available && (
                      <div className="absolute inset-0 bg-black/70 flex items-center justify-center">
                        <span className="bg-red-500 text-white px-4 py-2 rounded-full font-bold">
                          Tidak Tersedia
                        </span>
                      </div>
                    )}
                    <div className="absolute bottom-4 right-4">
                      <span className="bg-yellow-500 text-black px-3 py-1 rounded-full font-bold">
                        Rp {item.price.toLocaleString('id-ID')}
                      </span>
                    </div>
                  </div>

                  <div className="p-6">
                    <h3 className="text-xl font-bold text-white mb-2">{item.name}</h3>
                    <p className="text-gray-300 text-sm mb-4">{item.description}</p>
                    
                    {item.available && (
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => addToCart(item)}
                        className="w-full whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-add-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                        Tambah ke Keranjang
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex justify-between">
              <Button
                variant="outline"
                size="lg"
                onClick={handlePrevStep}
                className="whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Kembali
              </Button>
              <Button
                variant="primary"
                size="lg"
                onClick={handleNextStep}
                className="whitespace-nowrap cursor-pointer"
              >
                {orderStep === 2 ? 'Lanjut ke Minuman' : 'Review Pesanan'}
                <i className="ri-arrow-right-line ml-2 w-5 h-5 flex items-center justify-center"></i>
              </Button>
            </div>
          </div>
        )}

        {/* Step 4: Review & Order */}
        {orderStep === 4 && (
          <div>
            <div className="text-center mb-8">
              <h2 className="text-4xl font-bold text-white mb-4">Review Pesanan</h2>
              <p className="text-gray-300">Periksa kembali pesanan Anda sebelum konfirmasi</p>
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              {/* Order Summary */}
              <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Ringkasan Pesanan</h3>
                
                <div className="mb-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-300">Meja:</span>
                    <span className="text-white font-bold">{selectedTable}</span>
                  </div>
                </div>

                <div className="space-y-4 mb-6">
                  {cart.map((item) => (
                    <div key={item.id} className="flex items-center justify-between bg-gray-900/50 rounded-2xl p-4">
                      <div className="flex-1">
                        <h4 className="text-white font-semibold">{item.name}</h4>
                        <p className="text-gray-400 text-sm">Rp {item.price.toLocaleString('id-ID')}</p>
                      </div>
                      <div className="flex items-center space-x-3">
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity - 1)}
                          className="w-8 h-8 bg-red-600 text-white rounded-full flex items-center justify-center cursor-pointer"
                        >
                          <i className="ri-subtract-line w-4 h-4 flex items-center justify-center"></i>
                        </button>
                        <span className="text-white font-bold w-8 text-center">{item.quantity}</span>
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                          className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center cursor-pointer"
                        >
                          <i className="ri-add-line w-4 h-4 flex items-center justify-center"></i>
                        </button>
                      </div>
                      <div className="ml-4">
                        <span className="text-yellow-400 font-bold">
                          Rp {(item.price * item.quantity).toLocaleString('id-ID')}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-600 pt-4">
                  <div className="flex items-center justify-between text-xl font-bold">
                    <span className="text-white">Total:</span>
                    <span className="text-yellow-400">Rp {getTotalPrice().toLocaleString('id-ID')}</span>
                  </div>
                </div>
              </div>

              {/* Customer Info */}
              <div className="bg-gradient-to-br from-red-900/20 to-yellow-900/20 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
                <h3 className="text-2xl font-bold text-white mb-6">Informasi Pemesan</h3>
                
                <div className="space-y-6 mb-8">
                  <div>
                    <label className="block text-white font-semibold mb-2">Nama Lengkap *</label>
                    <input
                      type="text"
                      value={customerInfo.name}
                      onChange={(e) => setCustomerInfo({...customerInfo, name: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm"
                      placeholder="Masukkan nama lengkap"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-white font-semibold mb-2">No. WhatsApp *</label>
                    <input
                      type="tel"
                      value={customerInfo.phone}
                      onChange={(e) => setCustomerInfo({...customerInfo, phone: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm"
                      placeholder="+62 xxx xxxx xxxx"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-white font-semibold mb-2">Catatan Khusus</label>
                    <textarea
                      value={customerInfo.notes}
                      onChange={(e) => setCustomerInfo({...customerInfo, notes: e.target.value})}
                      rows={3}
                      className="w-full px-4 py-3 bg-gray-800/50 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:border-red-500 focus:outline-none transition-colors text-sm resize-none"
                      placeholder="Catatan untuk dapur atau permintaan khusus"
                    />
                  </div>
                </div>

                <div className="flex flex-col space-y-4">
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={handleSubmitOrder}
                    disabled={isSubmitting || cart.length === 0 || !selectedTable}
                    className="w-full whitespace-nowrap cursor-pointer"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line mr-2 w-5 h-5 flex items-center justify-center animate-spin"></i>
                        Mengirim Pesanan...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                        Kirim Pesanan ke Sistem
                      </>
                    )}
                  </Button>
                  
                  <p className="text-gray-400 text-sm text-center">
                    Pesanan akan langsung masuk ke sistem kasir dan dapur
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Table Info Modal */}
      {showTableInfo && selectedTableInfo && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-3xl border border-red-500/20 max-w-md w-full">
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-2xl font-bold text-white">Info {selectedTableInfo.name}</h3>
                <button
                  onClick={() => setShowTableInfo(false)}
                  className="w-10 h-10 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-white w-5 h-5 flex items-center justify-center"></i>
                </button>
              </div>

              <div className="space-y-6">
                {/* Table Details */}
                <div className="bg-gray-900/50 rounded-2xl p-4 border border-gray-700">
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <h4 className="text-lg font-bold text-white">{selectedTableInfo.name}</h4>
                      <p className="text-gray-300 text-sm">{selectedTableInfo.location}</p>
                    </div>
                    <div className={`px-3 py-1 rounded-full text-xs font-bold ${
                      selectedTableInfo.status === 'occupied' ? 'bg-red-500 text-white' : 'bg-yellow-500 text-black'
                    }`}>
                      {selectedTableInfo.status === 'occupied' ? 'Terisi' : 'Reserved'}
                    </div>
                  </div>
                  
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-400">Kapasitas:</span>
                      <span className="text-white">{selectedTableInfo.capacity}</span>
                    </div>
                  </div>
                </div>

                {/* Current Guest Info (for occupied tables) */}
                {selectedTableInfo.status === 'occupied' && selectedTableInfo.currentGuest && (
                  <div className="bg-red-900/20 rounded-2xl p-4 border border-red-500/30">
                    <h4 className="text-lg font-bold text-red-400 mb-4">
                      <i className="ri-user-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      Tamu Saat Ini
                    </h4>
                    <div className="space-y-3 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-300">Nama:</span>
                        <span className="text-white font-semibold">{selectedTableInfo.currentGuest.name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Jumlah Tamu:</span>
                        <span className="text-white">{selectedTableInfo.currentGuest.partySize} orang</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Mulai Makan:</span>
                        <span className="text-white">{selectedTableInfo.currentGuest.startTime}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Estimasi Selesai:</span>
                        <span className="text-yellow-400 font-bold">{selectedTableInfo.currentGuest.estimatedEnd}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Nilai Pesanan:</span>
                        <span className="text-green-400 font-bold">Rp {selectedTableInfo.currentGuest.orderValue.toLocaleString('id-ID')}</span>
                      </div>
                      {selectedTableInfo.currentGuest.specialRequests && (
                        <div>
                          <span className="text-gray-300">Permintaan Khusus:</span>
                          <p className="text-white text-xs mt-1 bg-gray-800/50 rounded-lg p-2">
                            {selectedTableInfo.currentGuest.specialRequests}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Reservation Info (for reserved tables) */}
                {selectedTableInfo.status === 'reserved' && selectedTableInfo.reservation && (
                  <div className="bg-yellow-900/20 rounded-2xl p-4 border border-yellow-500/30">
                    <h4 className="text-lg font-bold text-yellow-400 mb-4">
                      <i className="ri-calendar-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                      Info Reservasi
                    </h4>
                    <div className="space-y-3 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-300">Nama:</span>
                        <span className="text-white font-semibold">{selectedTableInfo.reservation.name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Waktu:</span>
                        <span className="text-yellow-400 font-bold">{selectedTableInfo.reservation.time}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-300">Jumlah Tamu:</span>
                        <span className="text-white">{selectedTableInfo.reservation.partySize} orang</span>
                      </div>
                      {selectedTableInfo.reservation.specialRequests && (
                        <div>
                          <span className="text-gray-300">Permintaan Khusus:</span>
                          <p className="text-white text-xs mt-1 bg-gray-800/50 rounded-lg p-2">
                            {selectedTableInfo.reservation.specialRequests}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Wait Time Info */}
                <div className="bg-blue-900/20 rounded-2xl p-4 border border-blue-500/30">
                  <h4 className="text-lg font-bold text-blue-400 mb-3">
                    <i className="ri-time-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                    Estimasi Ketersediaan
                  </h4>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-white mb-2">
                      {getEstimatedWaitTime(selectedTableInfo)}
                    </div>
                    <p className="text-gray-300 text-sm">
                      {selectedTableInfo.status === 'occupied' 
                        ? 'Estimasi waktu tunggu hingga meja tersedia'
                        : 'Meja sedang direservasi untuk waktu tersebut'
                      }
                    </p>
                  </div>
                </div>

                {/* Actions */}
                <div className="space-y-3">
                  {selectedTableInfo.status === 'occupied' && (
                    <Button
                      variant="outline"
                      size="lg"
                      onClick={() => {
                        setShowTableInfo(false);
                        // You could implement a waitlist feature here
                        alert('Fitur waitlist akan segera tersedia! Silakan coba meja lain atau kembali nanti.');
                      }}
                      className="w-full whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-notification-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                      Tambah ke Waitlist
                    </Button>
                  )}
                  
                  <Button
                    variant="primary"
                    size="lg"
                    onClick={() => setShowTableInfo(false)}
                    className="w-full whitespace-nowrap cursor-pointer"
                  >
                    Pilih Meja Lain
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
